export default "__VITE_ASSET__DLhZuu8H__"